export default {
  fontFamily: 'Montserrat, sans-serif',
  color: 'black',
  h1: {
    fontWeight: 900,
    fontSize: 49,
    textTransform: 'uppercase',
    letterSpacing: '-0.24px',
    marginBottom: '2rem',
  },
  h2: {
    fontWeight: 900,
    fontSize: 29,
    letterSpacing: '-0.24px',
    textTransform: 'uppercase',
    marginBottom: '2rem',
  },
  h3: {
    fontWeight: 900,
    fontSize: 24,
    letterSpacing: '-0.06px',
    textTransform: 'uppercase',
    marginBottom: '2rem',
  },
  body2: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
    fontFamily: 'Montserrat, sans-serif',
    marginBottom: '1.5rem',
  },
  h4: {
    fontWeight: 900,
    fontSize: 24,
    letterSpacing: '-0.06px',
    textTransform: 'uppercase',
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
};
